// src/lib/kinema/core/commands/middleware.ts
import type {
  Command,
  Middleware,
  MiddlewareFn,
  MiddlewareContext,
  EditorState,
} from '../types';

export function createMiddleware<T>(
  command: Command<T>,
  fn: MiddlewareFn<T>,
): Middleware {
  return { command, fn: fn as MiddlewareFn };
}

export function runMiddleware<T>(
  command: Command<T>,
  payload: T,
  middlewares: Middleware[],
  state: EditorState,
): T | null {
  let current: T | null = payload;

  const context: MiddlewareContext = {
    getState: () => state,
    getOption: <V>(_key: string, defaultValue: V): V => defaultValue,
  };

  for (const mw of middlewares) {
    if (mw.command.type !== command.type) continue;
    if (current === null) break;
    current = mw.fn(current, context) as T | null;
  }

  return current;
}
